﻿import { Car } from "lucide-react";
import { Button } from "@/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { Input } from "@/components/ui/input";
import type { Customer } from "@/hooks/customers/useCustomerData";;

export function CustomerModal({
  editingCustomer,
  setEditingCustomer,
  saveCustomer,
}: {
  editingCustomer: Customer | null;
  setEditingCustomer: (c: Customer | null) => void;
  saveCustomer: any;
}) {
  return (
    <Dialog
      open={!!editingCustomer}
      onOpenChange={(open) => !open && setEditingCustomer(null)}
    >
      <DialogContent className="sm:max-w-[425px] bg-slate-900 border-slate-700 text-slate-100">
        <DialogHeader>
          <DialogTitle className="text-xl">
            {editingCustomer?.id ? "Editar Cliente" : "Novo Cliente"}
          </DialogTitle>
        </DialogHeader>
        {editingCustomer && (
          <form
            onSubmit={(e) => {
              e.preventDefault();
              const fd = new FormData(e.currentTarget);
              saveCustomer.mutate(
                {
                  id: editingCustomer.id,
                  name: fd.get("name") as string,
                  phone: fd.get("phone") as string,
                  email: fd.get("email") as string,
                  plate: fd.get("plate") as string,
                  model: fd.get("model") as string,
                  color: fd.get("color") as string,
                },
                {
                  onSuccess: () => setEditingCustomer(null),
                },
              );
            }}
            className="space-y-4 mt-2"
          >
            <div className="space-y-2">
              <label className="text-sm text-slate-300">Nome Completo *</label>
              <Input
                name="name"
                defaultValue={editingCustomer.name}
                required
                className="bg-slate-800 border-slate-700 text-white"
              />
            </div>
            <div className="grid grid-cols-2 gap-4">
              <div className="space-y-2">
                <label className="text-sm text-slate-300">
                  Telefone (WhatsApp)
                </label>
                <Input
                  name="phone"
                  defaultValue={editingCustomer.phone}
                  className="bg-slate-800 border-slate-700 text-white"
                />
              </div>
              <div className="space-y-2">
                <label className="text-sm text-slate-300">E-mail</label>
                <Input
                  name="email"
                  type="email"
                  defaultValue={editingCustomer.email}
                  className="bg-slate-800 border-slate-700 text-white"
                />
              </div>
            </div>

            <div className="border-t border-slate-800 pt-4 mt-2">
              <h4 className="text-sm font-bold text-slate-300 mb-3 flex items-center gap-2">
                <Car size={16} /> Adicionar Veículo (Opcional)
              </h4>
              <div className="grid grid-cols-3 gap-3">
                <div className="space-y-2">
                  <label className="text-xs text-slate-400">Placa</label>
                  <Input
                    name="plate"
                    className="bg-slate-800 border-slate-700 text-white uppercase font-bold tracking-widest text-xs"
                    placeholder="ABC-1234"
                    maxLength={8}
                  />
                </div>
                <div className="space-y-2">
                  <label className="text-xs text-slate-400">Modelo</label>
                  <Input
                    name="model"
                    className="bg-slate-800 border-slate-700 text-white text-xs"
                    placeholder="Ex: Onix"
                  />
                </div>
                <div className="space-y-2">
                  <label className="text-xs text-slate-400">Cor</label>
                  <Input
                    name="color"
                    className="bg-slate-800 border-slate-700 text-white text-xs"
                    placeholder="Ex: Prata"
                  />
                </div>
              </div>
            </div>

            <div className="pt-4 flex justify-end gap-2 border-t border-slate-800">
              <Button
                type="button"
                variant="ghost"
                onClick={() => setEditingCustomer(null)}
              >
                Cancelar
              </Button>
              <Button
                type="submit"
                disabled={saveCustomer.isPending}
                className="bg-blue-600 hover:bg-blue-700"
              >
                {saveCustomer.isPending ? "Salvando..." : "Salvar Cliente"}
              </Button>
            </div>
          </form>
        )}
      </DialogContent>
    </Dialog>
  );
}
